'use strict';

/**
 *
 *
 * @category   Module
 * @module     Export
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var Controller = require('./controller');
var Wreqr = require('./wreqr');
var ExportCollection = require('./collections/exports');

var ExportModule = Marionette.Module.extend({

    initialize: function(moduleName, app) {
        this.app = app;

        this.listenTo(app.vent, 'logged-in', function() {
            app.loadData(this.exportsCollection);
        }.bind(this));
    },

    onStart: function(options) {
        var app = this.app;

        this.exportsCollection = new ExportCollection();

        var controller = this.controller = new Controller({
            app: app,
            module: this,
        });

        this.wreqr = new Wreqr({
            app: app,
            module: this,
        });

        app.addInitializer(function(){
            app.router.processAppRoutes(controller, controller.routes);
        }.bind(this));
    },
});

module.exports = ExportModule;